<div class="af-content-wrapper">
  <af-card>
  <ng-container headline>{{ 'COMPANY-ADMIN.WELCOME' | translate }}</ng-container>

  </af-card>
</div>
